export default {"src":"/_next/static/media/gsc.bea7720e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};